import { combineReducers } from 'redux';

import { collectionsDuck } from '@eb/redux-destination';
import { DEFAULT_CURRENCY_FORMAT } from '@eb/intl';

import appReducer from './app/reducer';
import contentReducer from './content/reducer';
import headerReducer from './header/reducer';
import locationReducer from './location/reducer';
import organizers from './organizers/reducer';
import userReducer from './user/reducer';
import searchReducer from './search/reducer';
import suggestionsReducer from './search/suggestionsReducer';
import { fiveToFollow } from './organizerArticle/reducer';
import { UPDATE_ROOT_CONTEXT } from './rootActionTypes';

const rootReducer = combineReducers({
    app: appReducer,
    content: contentReducer,
    collections: collectionsDuck.reducer,
    location: locationReducer,
    suggestions: suggestionsReducer,
    user: userReducer,
    organizers,
    search: searchReducer,
    env: (state = {}) => state,
    currencyFormat: (state = DEFAULT_CURRENCY_FORMAT) => state,
    gaSettings: (state = {}) => state,
    fiveToFollow,
    shareOptions: (state = {}) => state,
    header: headerReducer,
    headerImageIndex: (state = '') => state,
});

export default function updateableRootReducer(state = {}, action) {
    let newState = state;

    if (action && action.type === UPDATE_ROOT_CONTEXT) {
        newState = action.payload;
    }

    return rootReducer(newState, action);
}
